import React, { useState } from 'react';
import './AdComposer.css';
import { CONTACT_INFO } from '../constants';

function AdComposer() {
  const [text, setText] = useState('');
  const [category, setCategory] = useState('Matrimonial');

  const categories = [
    'Matrimonial', 
    'Property Sale', 
    'Property Rent', 
    'Recruitment', 
    'Name Change', 
    'Obituary', 
    'Business', 
    'Lost & Found',
    'Services',
    'Others'
  ];

  // Simple estimation: ~30 chars per line is a standard newspaper column approximation
  const estimatedLines = text.length === 0 ? 0 : Math.max(1, Math.ceil(text.length / 30));

  const handleGetQuote = () => {
    const phoneNumber = CONTACT_INFO.PHONE.VALUE;
    const message = `Hi, I drafted this ${category} ad (approx ${estimatedLines} lines) on your website:\n\n"${text}"\n\nPlease let me know the cost for Times of India/Hindu.`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="ad-composer-section">
      <div className="container">
        <h2 className="section-title">Draft Your Ad & Preview</h2>
        <p className="section-subtitle">Type your ad text below to see how it looks in a newspaper column</p>

        <div className="composer-container">
            {/* Left: Input */}
            <div className="composer-input">
                <div className="form-group">
                    <label>Select Category</label>
                    <select value={category} onChange={(e) => setCategory(e.target.value)}>
                        {categories.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                </div>
                <div className="form-group">
                    <label>Ad Text</label>
                    <textarea
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="e.g., BRIDE WANTED for 28yr old MBA boy working in Bangalore. 12LPA. Seeks educated girl from decent family. Caste no bar. Contact: 9876543210"
                        rows={8}
                        maxLength={500}
                    />
                    <div className="char-count">{text.length}/500 characters</div>
                </div>
                <div className="composer-tips">
                    <h4>💡 Writing Tips:</h4>
                    <ul>
                        <li>Keep it concise to save money (charged per line).</li>
                        <li>Use standard abbreviations (e.g., 'BHK' instead of 'Bedroom Hall Kitchen').</li>
                        <li>Don't forget your contact number!</li>
                    </ul>
                </div>
            </div>

            {/* Right: Preview */}
            <div className="composer-preview">
                <h3>Newspaper Preview</h3>
                <div className="preview-paper">
                    <div className="classified-column">
                        <h3 className="category-header">{category}</h3>
                        <div className="ad-item">
                            <p>{text || <span className="placeholder-text">Your ad text will appear here exactly as it would in the newspaper...</span>}</p>
                        </div>
                    </div>
                </div>
                <div className="preview-stats">
                    <div className="stat-item">
                        <span className="stat-label">Characters</span>
                        <span className="stat-value">{text.length}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Approx. Lines</span>
                        <span className="stat-value">{estimatedLines}</span>
                    </div>
                </div>
                <button className="get-quote-btn" onClick={handleGetQuote} disabled={!text}>
                    Get Price on WhatsApp
                </button>
            </div>
        </div>
      </div>
    </section>
  );
}

export default AdComposer;
